export const login = {
  headline: 'Einloggen',
  info: 'Dieser Login ist nicht für den Maagtechnic Webshop gültig. Bitte erstellen Sie einen neuen auf unserer 3D Bestellportal Seite, um Zugang zu erhalten.',
  inputLabels: {
    userNameOrEmail: 'Nutzername oder E-Mail',
    password: 'Passwort',
    oldPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    repeatPassword: 'Passwort wiederholen'
  },
  mainActions: {
    login: 'Einloggen',
    register: 'Registrieren',
    forgotPassword: 'Passwort vergessen',
    resetPassword: 'Passwort zurücksetzen'
  },
  messages: {
    loginFailed: 'Benutzername und Passwort stimmen nicht überein.',
    membersOnly: '(nur registrierte Nutzer)',
    passwordResetSuccess: {
      header: 'Passwort zurückgesetzt',
      body: 'Ihr Passwort wurde zurückgesetzt. Sie können sich nun mit Ihrem neuen Passwort einloggen'
    },
  },
};
